"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeSummaryPagePremiumWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../commonFunctions");
var components_1 = require("@athena-portal/components");
var AnnualHomeSummaryPagePremiumWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeSummaryPagePremiumWidget, _super);
    function AnnualHomeSummaryPagePremiumWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.getRenewalPremiumWording = function () {
            var hasPendingRenewal = _this.verifyRenewalProposalStatus(services_1.POLICY_STATUS_PENDING_RENEWAL);
            if (!hasPendingRenewal) {
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            }
            var isMonthlyPayment = _this.props.interaction.factors.premiumType === services_1.PremiumType.monthly;
            var previousRenewalPrice = isMonthlyPayment
                ? _this.state.renewalProposal.paymentDetails.instalmentPlan.totalAmount
                : _this.state.renewalProposal.factors.annualPremium;
            var currentRenewalPrice = _this.props.interaction.uistate.totalRenewalAmount;
            if (previousRenewalPrice === currentRenewalPrice) {
                return (0, jsx_runtime_1.jsxs)("p", { className: "font-weight-semi-bold mb-0 margin-top-32", children: ["Your renewal price has stayed the same at ", (0, commonFunctions_1.getAmountToDisplay)(currentRenewalPrice)] });
            }
            else {
                return (0, jsx_runtime_1.jsxs)("p", { className: "font-weight-semi-bold mb-0 margin-top-32", children: ["Your renewal price has changed from ", (0, commonFunctions_1.getAmountToDisplay)(previousRenewalPrice), " to ", (0, commonFunctions_1.getAmountToDisplay)(currentRenewalPrice), "."] });
            }
        };
        _this.renderPremiumPanel = function (interaction, changesStartDate, additionalWording) {
            var hasDebtAndIsMTA = interaction.factors.debtAmount > 0 && (interaction.process === services_1.INTERACTION_PROCESS_MTA || interaction.process === services_1.INTERACTION_PROCESS_MTA_CHANGE_ADDRESS);
            var additionalPremium;
            var returnPremium;
            var paymentRequired;
            var refundRequired;
            if (hasDebtAndIsMTA) {
                additionalPremium = (0, commonFunctions_1.getAmountWithDecimalDigits)(interaction.factors.mtaAndDebtCombinedAdditionalAmount);
                returnPremium = (0, commonFunctions_1.getAmountWithDecimalDigits)(interaction.factors.mtaAndDebtCombinedReturnAmount);
                paymentRequired = interaction.factors.mtaAndDebtCombinedAdditionalAmount > 0;
                refundRequired = interaction.factors.mtaAndDebtCombinedReturnAmount > 0;
            }
            else {
                additionalPremium = (0, commonFunctions_1.getAmountWithDecimalDigits)(interaction.factors.additionalPremium);
                returnPremium = (0, commonFunctions_1.getAmountWithDecimalDigits)(interaction.factors.returnPremium);
                paymentRequired = interaction.factors.additionalPremium > 0;
                refundRequired = interaction.factors.returnPremium > 0;
            }
            var price = refundRequired ? "".concat(returnPremium, " refund") : additionalPremium;
            var renewalDecline = interaction.uistate.declineRenewal;
            var renewalWindowWording = _this.getRenewalPremiumWording();
            var premiumSpecificWording;
            if (paymentRequired) {
                premiumSpecificWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["You'll pay an additional ", additionalPremium] });
            }
            else if (refundRequired) {
                premiumSpecificWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["You'll receive a pro rata refund of ", returnPremium] });
            }
            else {
                premiumSpecificWording = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "There is no change in price" });
            }
            return ((0, jsx_runtime_1.jsxs)("div", { className: "panel text-center mb-4 mt-4 policy-change-price", children: [renewalDecline &&
                        (0, jsx_runtime_1.jsx)("p", { className: "ml-1 mb-1 warning-banner banner-warn additional-warning margin-top-0 margin-bottom-0", children: "Due to this change, if you continue you won't be able to renew at the end of your policy. You can make this change now (you'll be covered until your policy end date) or cancel the changes to allow the policy to renew." }), (0, jsx_runtime_1.jsx)("p", { className: "price font-weight-bold margin-bottom-16", children: price }), (0, jsx_runtime_1.jsx)("p", { className: "margin-bottom-32", children: "All figures include Insurance Premium Tax" }), (0, jsx_runtime_1.jsxs)("p", { className: "m-0", children: [premiumSpecificWording, " for the changes you have made from the ", changesStartDate, " to the end of your policy.", additionalWording, !renewalDecline && renewalWindowWording] }), (!hasDebtAndIsMTA) && _this.getUpfrontWording(interaction)] }));
        };
        _this.renderRenewalProposalPremiumPanel = function (interaction, changesStartDate, additionalWording) {
            var _a, _b, _c, _d;
            var currentRenewalPrice = interaction.factors.annualPremium;
            var currentTotalPremium = interaction.paymentDetails.instalmentPlan.totalAmount;
            var currentMonthlyPayment = interaction.paymentDetails.instalmentPlan.monthlyPayment;
            var renewalProposal = _this.state.renewalProposal;
            var hasPendingRenewal = _this.verifyRenewalProposalStatus(services_1.POLICY_STATUS_PENDING_RENEWAL);
            var previousRenewalPrice = hasPendingRenewal ? (_a = renewalProposal.factors.annualPremium) !== null && _a !== void 0 ? _a : 0 : 0;
            var previousRenewalMonthlyPrice = hasPendingRenewal ? (_d = (_c = (_b = renewalProposal.paymentDetails) === null || _b === void 0 ? void 0 : _b.instalmentPlan) === null || _c === void 0 ? void 0 : _c.monthlyPayment) !== null && _d !== void 0 ? _d : 0 : 0;
            var isMonthlyPayment = interaction.factors.premiumType === services_1.PremiumType.monthly;
            var priceChange;
            if (isMonthlyPayment) {
                priceChange = "".concat((0, commonFunctions_1.getAmountToDisplay)(previousRenewalMonthlyPrice), " / month\n                            to ").concat((0, commonFunctions_1.getAmountToDisplay)(currentMonthlyPayment), " / month");
            }
            else {
                priceChange = "".concat((0, commonFunctions_1.getAmountToDisplay)(previousRenewalPrice), " to ").concat((0, commonFunctions_1.getAmountToDisplay)(currentRenewalPrice));
            }
            var premiumSpecificWording;
            var noPriceChange = false;
            if (currentRenewalPrice > previousRenewalPrice) {
                premiumSpecificWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["has increased from ", priceChange, "."] });
            }
            else if (currentRenewalPrice < previousRenewalPrice) {
                premiumSpecificWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["has reduced from ", priceChange, "."] });
            }
            else {
                premiumSpecificWording = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "has not changed." });
                noPriceChange = !noPriceChange;
            }
            return ((0, jsx_runtime_1.jsxs)("div", { className: "panel text-center mb-4 mt-4 policy-change-price", children: [noPriceChange && (0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold margin-bottom-32", children: "Great news! Your renewal price has stayed the same." }), (0, jsx_runtime_1.jsxs)("p", { className: "m-0", children: ["Your ", !noPriceChange && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "updated" }), " renewal price is ", (0, jsx_runtime_1.jsx)("strong", { children: (0, commonFunctions_1.getAmountToDisplay)(currentRenewalPrice) })] }), isMonthlyPayment && (0, jsx_runtime_1.jsxs)("p", { className: "margin-bottom-16", children: ["As you've chosen to pay monthly your monthly instalments will be", ' ', (0, commonFunctions_1.getAmountToDisplay)(currentMonthlyPayment), ". The total you will pay including interest is ", (0, commonFunctions_1.getAmountToDisplay)(currentTotalPremium), "."] }), (0, jsx_runtime_1.jsx)("p", { className: "margin-bottom-32", children: "All figures include Insurance Premium Tax" }), (0, jsx_runtime_1.jsxs)("p", { className: "m-0", children: ["Following the changes you've made to take effect from your renewal date (", changesStartDate, "), your renewal price ", premiumSpecificWording] }), additionalWording && (0, jsx_runtime_1.jsx)("p", { className: "margin-top-32 margin-bottom-0", children: additionalWording })] }));
        };
        _this.getAdditionalWording = function (interaction) {
            var hasDebtAndIsMTA = interaction.factors.debtAmount > 0 && (interaction.process === services_1.INTERACTION_PROCESS_MTA || interaction.process === services_1.INTERACTION_PROCESS_MTA_CHANGE_ADDRESS);
            var debtAmount = (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.debtAmount);
            if (hasDebtAndIsMTA) {
                return (0, jsx_runtime_1.jsxs)("p", { className: "margin-top-16", children: ["This takes into account the outstanding payment of ", debtAmount, " we didn't receive this month."] });
            }
            else {
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            }
        };
        _this.state = {
            oldInteraction: {},
            dataLoaded: false,
            renewalProposal: undefined,
            remainingAmountPresent: false
        };
        return _this;
    }
    AnnualHomeSummaryPagePremiumWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicy(this.props.engine.getInteraction().agreementNumber).subscribe(function (policy) {
            _this.setState({
                oldInteraction: policy.interaction
            }, function () {
                _this.customerPortalService.getRenewalProposal(policy.policyNumber).subscribe(function (renewalProposal) {
                    _this.setState({
                        renewalProposal: renewalProposal,
                        dataLoaded: true
                    });
                });
                var agreementVersionIds = policy.policyHistoryList.map(function (ph) { return ph.id; });
                _this.customerPortalService.getCombinedInstalmentsInfo(agreementVersionIds)
                    .subscribe(function (instalmentsInfo) {
                    var remainingAmountPresent = Math.abs(instalmentsInfo === null || instalmentsInfo === void 0 ? void 0 : instalmentsInfo.remainingAmount) !== 0;
                    _this.setState({
                        remainingAmountPresent: remainingAmountPresent
                    });
                });
            });
        });
    };
    AnnualHomeSummaryPagePremiumWidget.prototype.render = function () {
        var interaction = this.props.engine.getInteraction();
        if (this.state.dataLoaded) {
            if (interaction.factors && this.state.oldInteraction.factors) {
                var changesStartDate = (0, commonFunctions_1.formatDateDMY)(interaction.headerInfo.startDate);
                var isRenewalProposal = this.props.interaction.status === services_1.POLICY_STATUS_PENDING_RENEWAL_PENDING_UPDATE;
                var additionalWording = this.getAdditionalWording(interaction);
                if (isRenewalProposal) {
                    return this.renderRenewalProposalPremiumPanel(interaction, changesStartDate, additionalWording);
                }
                else {
                    return this.renderPremiumPanel(interaction, changesStartDate, additionalWording);
                }
            }
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    AnnualHomeSummaryPagePremiumWidget.prototype.verifyRenewalProposalStatus = function (checkStatus) {
        return this.state.renewalProposal != null && this.state.renewalProposal.status === checkStatus;
    };
    AnnualHomeSummaryPagePremiumWidget.prototype.getUpfrontWording = function (interaction) {
        var upfrontPaymentAmount = (0, commonFunctions_1.getUpfrontPaymentAmount)(interaction.factors);
        var remainingPaymentAmount = (0, commonFunctions_1.getRemainingSpreadAmount)(interaction.factors);
        var upfrontInterestCorrectionRefund = Math.abs(interaction.paymentDetails.instalmentPlan.upfrontInterestCorrectionRefund);
        var upfrontInterestCorrectionRefundCondition = upfrontInterestCorrectionRefund !== null && upfrontInterestCorrectionRefund > 1;
        return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [upfrontInterestCorrectionRefundCondition &&
                    (0, jsx_runtime_1.jsxs)("p", { className: "margin-top-32", children: ["You'll also receive an upfront refund of ", (0, jsx_runtime_1.jsx)("strong", { children: (0, commonFunctions_1.getAmountToDisplay)(upfrontInterestCorrectionRefund) }), ' ', "due to the interest you paid."] }), upfrontPaymentAmount && this.state.remainingAmountPresent &&
                    (0, jsx_runtime_1.jsxs)("p", { className: "margin-top-32", children: ["Pay ", (0, jsx_runtime_1.jsx)("strong", { children: upfrontPaymentAmount }), " upfront now and the remaining balance of ", (0, jsx_runtime_1.jsx)("strong", { children: remainingPaymentAmount }), " by monthly payments."] })] });
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualHomeSummaryPagePremiumWidget.prototype, "customerPortalService", void 0);
    return AnnualHomeSummaryPagePremiumWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeSummaryPagePremiumWidget = AnnualHomeSummaryPagePremiumWidget;
//# sourceMappingURL=AnnualHomeSummaryPagePremiumWidget.js.map